
export const TEMPLATES_WHATSAPP_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-5 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5"
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-sm transition-shadow",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500"
    },
    filters: {
        grid: "grid grid-cols-1 md:grid-cols-3 gap-4",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 block",
        select: "w-full bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200",
        searchInput: "pl-9 bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200"
    },
    drawer: {
        backdrop: "absolute inset-0 bg-black/40 backdrop-blur-[2px]",
        container: "relative w-[90%] max-w-7xl h-full bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-300",
        header: {
            container: "flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white",
            title: "text-base font-bold text-gray-900",
            subtitle: "text-xs text-gray-500 mt-0.5",
            actions: "flex items-center gap-3"
        },
        content: {
            container: "flex-1 flex overflow-hidden min-h-0",
            leftColumn: "w-[62%] p-6 overflow-y-auto max-h-full border-r border-gray-100 bg-white",
            rightColumn: "w-[38%] p-6 overflow-y-auto max-h-full bg-gradient-to-b from-slate-50 to-slate-100/50",
            section: {
                container: "mb-6",
                titleWrapper: "flex items-center gap-3 mb-5",
                iconBox: "w-8 h-8 bg-[#F3E8FF] rounded-lg flex items-center justify-center text-[#7C3AED]",
                title: "text-base font-bold text-gray-900",
                label: "block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 flex items-center gap-2",
                input: {
                    base: "text-sm border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200",
                    disabled: "bg-gray-50 cursor-not-allowed text-gray-500"
                }
            }
        },
        footer: {
            container: "border-t border-gray-100 bg-gray-50/80 px-6 py-3 flex items-center justify-between"
        },
        preview: {
            phoneFrame: "bg-gray-900 rounded-[2.5rem] p-1.5 shadow-xl mx-auto max-w-[300px]",
            phoneInner: "bg-gray-900 rounded-[2rem] overflow-hidden",
            notch: "flex justify-center py-2 bg-gray-900",
            notchPill: "w-20 h-5 bg-gray-800 rounded-full",
            whatsappHeader: "bg-[#008069] px-3 py-2.5 flex items-center gap-2.5",
            chatArea: "min-h-[320px] p-3",
            messageBubble: "bg-[#d9fdd3] rounded-xl rounded-tr-sm p-2.5 shadow-sm max-w-[88%] min-w-[160px] relative ml-auto",
            messageTail: "absolute -right-1 top-0 w-0 h-0 border-l-[8px] border-l-[#d9fdd3] border-t-[8px] border-t-transparent",
            inputBar: "bg-[#f0f0f0] px-2 py-2 flex items-center gap-2",
            homeIndicator: "flex justify-center py-2 bg-gray-900"
        }
    },
    card: {
        container: "group hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-200 hover:border-[#7C3AED]/40 hover:ring-1 hover:ring-[#7C3AED]/10 rounded-xl bg-white overflow-hidden"
    }
};
